<template>
    <div>
        <buttonlist
                @help="help"
                @search="search"
                @reflash="reflash"
                @exps="exps"
                ref="SetBtn"
        ></buttonlist>
        <div style="margin-top: 2px">
            <el-button type="primary" size="mini" @click="transfer" :disabled="!btn.transfer">{{ $t('getapi[6023]') }}</el-button>
            <el-button type="primary" size="mini" @click="transferwithdate">{{ $t('getapi[7211]')}}</el-button>
            <el-button type="primary" size="mini" @click="MergeOrders" :disabled="!btn.mergeorder">{{ $t('getapi[13320 ]') }}</el-button>
            <el-button type="primary" size="mini" @click="diffcalc" :disabled="!btn.diffcalc">{{ $t('getapi[13308]') }}</el-button>
            <el-button type="primary" size="mini" @click="automctopr" :disabled="!btn.mctopr"  >{{ $t('getapi[13540]') }}</el-button>
            <!-- v-if="btn.mctopr" -->
        </div>
        <div id="xpane-0">
        <vxe-table
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                resizable
                stripe
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                @checkbox-change="handleSelectionChange"
                style="width: 100%; margin-top:0px"
                @sort-change="sortChange"
                :default-sort="sortRule"
                @checkbox-all="handleSelectionChangeAll"
                @checkbox-range-end="handleSelectionChange"
                :checkbox-config="{highlight: true, range: true}"
                :mouse-config="{selected:true, extension: true}"
                ref="singleTable"
                :row-class-name="tableRowClassName"
        >
            <vxe-table-column type="checkbox" align="center" width="40"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="exclusively_num" :title="$t('getapi[871]')"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="llc" :title="$t('getapi[7212]')" align="right"></vxe-table-column>
            <vxe-table-column field="partcode" :title="$t('getapi[112]')" sortable>
                <template slot-scope="scope" >
                    <span v-if="scope.row.suggest_order_date != scope.row.with_order_date && scope.row.with_order_date != ''" style="color:red">
                        {{scope.row.partcode}}
                    </span>
                    <span v-if="scope.row.suggest_order_date == scope.row.with_order_date || scope.row.with_order_date == ''">
                        {{scope.row.partcode}}
                    </span>
                </template>
            </vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="partversion" :title="$t('getapi[149]')"></vxe-table-column>
            <vxe-table-column field="calc_date" :title="$t('getapi[4053]')">
                <template slot-scope="scope" >
                    {{scope.row.calc_date | timeFormat}}
                </template>
            </vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="calc_qty" :title="$t('getapi[1628]')"
                             align="right"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="measure_unit" :title="$t('getapi[888]')"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="excess_qty" :title="$t('getapi[13290]')"></vxe-table-column>            
            <vxe-table-column show-overflow-tooltip field="item_code" :title="$t('getapi[876]')"></vxe-table-column>
            <vxe-table-column field="suggest_order_date" :title="$t('getapi[7213]')">
                <template slot-scope="scope" >
                    {{scope.row.suggest_order_date | timeFormat}}
                </template>
            </vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="default_schedule_person" :title="$t('getapi[7214]')"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="mp_flag" :title="$t('getapi[4241]')"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="lead_time" :title="$t('getapi[7215]')" align="right"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="products" :title="$t('getapi[145]')"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="qc_leadtime" :title="$t('getapi[6006]')"
                             align="right"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="part_engtype_name"
                             :title="$t('getapi[118]')"></vxe-table-column>
            <vxe-table-column field="with_order_date" :title="$t('getapi[7216]')">
                <template slot-scope="scope" >
                    <span v-if="scope.row.suggest_order_date != scope.row.with_order_date && scope.row.with_order_date != ''" style="color:red">
                        {{scope.row.with_order_date | timeFormat}}
                    </span>
                    <span v-if="scope.row.suggest_order_date == scope.row.with_order_date || scope.row.with_order_date == ''">
                        {{scope.row.with_order_date | timeFormat}}
                    </span>
                </template>
            </vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="with_days" :title="$t('getapi[153]')"
                             align="right"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="with_sort" :title="$t('getapi[7217]')" align="right"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="with_remark" :title="$t('getapi[7218]')"></vxe-table-column>
        </vxe-table>
        </div>
        <div style="width:100%;height:20px;text-align: center">
            <span style="color:red;font-size: 20px">{{$t('getapi[7219]')}}{{num}}{{$t('getapi[7220]')}}</span>
        </div>
        <el-row>
            <span style="font-size: 20px">{{$t('getapi[201]')}}{{total}}{{$t('getapi[6771]')}}</span>
        </el-row>
       <!-- <el-row>
            <el-col :span="18">
                <el-pagination
                        style="margin-top: 1em"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400, 1000]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 60px;color: #545c64;font-size: 95%;">表名/视图名称:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>-->
        <serce :isVisible="isVisible" queryData="MRP_TranOrder_Pur" ref="ser" @getser="serclick"></serce>

        <selector :isVisible="false"  :isBatch=false :isSplitPage=true :postUrl="'/MRP/Tool/GetMRPItemPopupList'" @callback="getitem" ref="input"></selector>

        <el-dialog v-dialogDrag :visible.sync="isShowTransfer" :title="$t('getapi[6023]')" width="15%" :modal-append-to-body="false">
            <div>
                <table>
                    <tr>
                        <td>{{$t('getapi[1480]')}}</td>
                        <td>
                            <el-input v-model="requisition_no" type="text" size="mini" style="width:120px"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[4158]')}}</td>
                        <td>
                            <routejump :urlNo="5">
                            <el-input
                                    v-model="item_code"
                                    type="text"
                                    readonly
                                    size="mini"
                                    style="width:120px"
                            >
                                <i class="el-icon-edit el-input__icon" slot="suffix" @click="selectitem()"></i>
                            </el-input>
                            </routejump>
                        </td>
                    </tr>
                </table>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="isShowTransfer = false" size="mini">{{$t('getapi[6]')}}</el-button>
				<el-button type="primary" @click="confirmTransfer" size="mini">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>

    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: '2_mrptranspurorder',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3 - Common.reduceTableHeight3
            },
        },
        data() {
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: 100000, // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                selectData: [],
                requisition_no: '', // 计划标识
                item_code: '', // 项目编码
                isShowTransfer: false,
                btn: {
                    transfer: false,
                    diffcalc:false,
                    mergeorder:false,
                    mctopr:false,
                },
                num: 0, // 建议合并转单的数量
                scrollTop:0,
                sortRule: {property:null,order:null},
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(0)
                    }, 500);
                })
            },
        },
        mounted: function () {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6597]"),'MRP');
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                that.btnauthority()
            },
            btnauthority() {
                let that = this;
                that.btn.transfer = false
                that.btn.diffcalc = false
                that.btn.mergeorder = false    
                that.btn.mctopr = false    
                            
                
                if (that.selectData.length > 0) {
                    that.btn.transfer = true
                }

                if (that.$limits.authority('plv4', 601, 1) ==1 ) {
                    if (that.selectData.length > 0) {                        
                        that.btn.mergeorder = true
                    }
                }
                if (that.$limits.authority('plv4', 605, 1) ==1 ) {
                     that.btn.mctopr = true                    
                }
                if (that.$limits.authority('plv4', 602, 1) ==1 ) {                    
                    that.btn.diffcalc = true
                }

                
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('2_mrptranspurorder',val)
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'MRP_TranOrder_Pur');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            handleSelectionChange({checked, records }) {
                let that = this;
                that.selectData = records;
                that.btnauthority()
            },
            //表格背景
            tableRowClassName({row, rowIndex}) {
                row.index = rowIndex;
                if (row.excess_qty>0) {
                    console.log(row.excess_qty)
                    return 'yellow';
                } 
            },
            //全选
            handleSelectionChangeAll({ records }){
                let that = this;
                that.selectData = records;
                that.btnauthority()
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/MRP/Tool/GetMrpTranPurOrderDataList', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.selectData = []
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                        that.getInfo()
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                    that.loading = false;
                });
            },
            getInfo(){
              let that = this
              that.num = 0
              for(let i=0;i<that.dataSet.length;i++){
                  if(that.dataSet[i].suggest_order_date != that.dataSet[i].with_order_date && that.dataSet[i].with_order_date != ''){
                      that.num ++
                  }
              }
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac,
                    LangType:that.$processdata.getLang(),
                    fromname: that.$t('getapi[6597]')
                };
                that.$http.urlpost('/MRP/Tool/GetMrpTranPurOrderToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            selectitem() {
                let that = this;
                that.$refs.input.clearInput(true);
            },
            getitem(val) {
                let that = this;
                that.item_code = val.item_name;
            },
            // 转单
            transfer() {
                let that = this;
                that.isShowTransfer = true;
                that.requisition_no = ''
                that.item_code = ''
            },
            
            confirmTransfer() {
                let that = this;
                let parm = {
                    requisition_no: that.requisition_no,
                    item_code: that.item_code,
                    Lists: [],
                    LangType: that.$processdata.getLang(),
                }
                for (let i = 0; i < that.selectData.length; i++) {
                    parm.Lists = [...parm.Lists, {
                        exclusively_num: that.selectData[i].exclusively_num,
                        partcode: that.selectData[i].partcode,
                        partversion: that.selectData[i].partversion,
                        calc_qty: that.selectData[i].calc_qty,
                        calc_date: that.selectData[i].calc_date
                    }]
                }
                that.$http.urlpost('/MRP/Tool/MrpTranPurOrder', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        that.getView()
                        that.isShowTransfer = false;
                    }
                });
            },
            diffcalc() {               
                let that = this;               
                that.$http.urlpost('/MRP/Tool/UpExcessQtyByMrpMOQ', null, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        that.getView()
                    }
                });
            },
            automctopr() {               
                let that = this; 
                that.btn.mctopr=false;
                let parm = {
                    Lists: [],
                    LangType: that.$processdata.getLang(),
                }    
                for (let i = 0; i < that.selectData.length; i++) {
                    parm.Lists = [...parm.Lists, {
                        item_code: that.selectData[i].item_code, 
                    }]
                }       
                that.$http.urlpost('/MRP/Tool/AutoMctoPrtoPur', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        that.getView()
                    }
                    that.btn.mctopr=true;
                });
            },
            MergeOrders() {

                let that = this;
                let parm = {
                    Lists: [],
                    LangType: that.$processdata.getLang(),
                }
                for (let i = 0; i < that.selectData.length; i++) {
                    parm.Lists = [...parm.Lists, {
                        exclusively_num: that.selectData[i].exclusively_num,
                        partcode: that.selectData[i].partcode,
                        partversion: that.selectData[i].partversion,
                        calc_qty: that.selectData[i].calc_qty,
                        calc_date: that.selectData[i].calc_date,
                        excess_qty:that.selectData[i].excess_qty,
                    }]
                }
                that.$http.urlpost('/MRP/Tool/MrpTranDiffCalc', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        that.getView()
                    }
                });
                
            },
            // 计算合并下单
            transferwithdate() {
                let that = this
                that.$http.urlpost('/MRP/Tool/MRPTranOrderWithDate', '', function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getView()
                    }
                });
            },
            // 排序
            sortChange(column){
                let that = this
                let name = column.property
                if(column.order == "asc"){
                    let compare = function (obj1, obj2) {
                        let val1 = obj1[name];
                        let val2 = obj2[name];
                        if (val1 < val2) {
                            return -1;
                        } else if (val1 > val2) {
                            return 1;
                        } else {
                            return that.dataSet.indexOf(obj1) - that.dataSet.indexOf(obj2);
                        }
                    }
                    that.dataSet.sort(compare);
                    that.dataSet = [...that.dataSet]
                } else if(column.order == "desc"){
                    let compare = function (obj1, obj2) {
                        let val1 = obj1[name];
                        let val2 = obj2[name];
                        if (val1 < val2) {
                            return 1;
                        } else if (val1 > val2) {
                            return -1;
                        } else {
                            return that.dataSet.indexOf(obj2) - that.dataSet.indexOf(obj1);
                        }
                    }
                    that.dataSet.sort(compare);
                    that.dataSet = [...that.dataSet]
                }
                that.sortRule.order = column.order
                that.sortRule.property = column.property
            },
           /* InitColor() {
                if (myRed == null) {
                    myRed = new System.Windows.Forms.DataGridViewCellStyle();
                    myRed.BackColor = Color.Red;
                    myRed.ForeColor = Color.White;
                }
                if (myDefault == null) {
                    myDefault = this.partcode.DefaultCellStyle;
                }
                if (myDefault == myRed) {
                    myDefault = new DataGridViewCellStyle();
                    myDefault.Alignment = System.Windows.Forms.DataGridViewContentAlignment.MiddleLeft;
                }

                // [i]["with_order_date"].ToString()
                this.dgvMRPResult.ClearSelection();
                int
                col_1 = this.partcode.Index;
                int
                col_2 = this.with_order_date.Index;
                int
                col_3 = this.suggest_order_date.Index;

                int
                x = 0;
                this.Cursor = Cursors.WaitCursor;
                for (int i = 0;
                i < this.dgvMRPResult.RowCount;
                i++
            )
                {

                    object
                    obj = this.dgvMRPResult.Rows[i].Cells[col_2].Value;
                    string
                    with_order_date;
                    if (obj == null) {
                        with_order_date = string.Empty;
                    }
                    else {
                        with_order_date = obj.ToString();
                    }

                    obj = this.dgvMRPResult.Rows[i].Cells[col_3].Value;
                    string
                    suggest_order_date;
                    if (obj == null) {
                        suggest_order_date = string.Empty;
                    }
                    else {
                        suggest_order_date = obj.ToString();
                    }
                    if (String.IsNullOrEmpty(with_order_date) || suggest_order_date == with_order_date) {
                        this.dgvMRPResult.Rows[i].Cells[col_1].Style = myDefault;
                        this.dgvMRPResult.Rows[i].Cells[col_2].Style = myDefault;
                    }
                }
            }*/
        }
    };
</script>

<style scoped lang="less">
/deep/ .yellow {
        background: #fff866 !important;
    }

    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    
</style>
